import axios from 'axios'
import { getCachedBibleChapter, cacheBibleChapter } from './offlineCache'
import { INewBibleResponse } from '../utils/types'

/**
 * Fetches a Bible chapter, serving from IndexedDB cache when available.
 * Falls back to network and caches the result for future offline use.
 */
export const fetchBibleChapter = async (bookId: string, chapterId: string) => {
	const cached = await getCachedBibleChapter(bookId, chapterId)
	if (cached) {
		return { data: { content: cached } as INewBibleResponse }
	}

	// Without a timeout a stalled request on a weak connection hangs the
	// modal's loader indefinitely instead of surfacing an error the user can retry.
	const res = await axios.get<INewBibleResponse>(
		`https://bible-api.nlwc.church/books/${bookId}/chapters/${chapterId}/verse/KJV`,
		{ timeout: 20000 }
	)

	if (res.data?.content) {
		cacheBibleChapter(bookId, chapterId, res.data.content)
	}

	return res
}
